import { render, staticRenderFns } from "./projectWasteGoodsDetails.vue?vue&type=template&id=0edece07&scoped=true&"
import script from "./projectWasteGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./projectWasteGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./projectWasteGoodsDetails.vue?vue&type=style&index=0&id=0edece07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edece07",
  null
  
)

component.options.__file = "projectWasteGoodsDetails.vue"
export default component.exports